import PageSerializer from '@linc-technologies/linced-common/serializers/posts/page';

export default class Page extends PageSerializer {
  normalize(model, hash) {
    hash.assessment_ids = hash.assessmentIds;
    return super.normalize(...arguments);
  }
}
